
import { types } from "mobx-state-tree";
import AgentStore from "./Agents/AgentStore";
import TeamStore from "./Teams/TeamStore";
import LocationStore from "./Locations/LocationStore";
import ReasonCodeStore from "./ReasonCodes/ReasonCodeStore";
import StatusCodeStore from "./StatusCodes/StatusCodeStore";
import UserPermissionStore from "./UserPermissions/UserPermissionStore";
import PasswordHintStore from "./PasswordHints/PasswordHintStore";
import CurrentUser from "./CurrentUser";
import makeInspectable from 'mobx-devtools-mst';

const RootModel = types.model('RootModel', {
  currentUser: CurrentUser,
  agentStore: AgentStore,
  teamStore: TeamStore,
  locationStore: LocationStore,
  reasonCodeStore: ReasonCodeStore,
  statusCodeStore: StatusCodeStore,
  permissionStore: UserPermissionStore,
  passwordHintStore: PasswordHintStore,
});

let initialState = RootModel.create({
  currentUser: {},
  agentStore: { agents: [] },
  teamStore: { teams: [] },
  locationStore: { locations: [] },
  reasonCodeStore: { reasonCodes: [] },
  statusCodeStore: { statusCodes: [] },
  permissionStore: { permissions: [] },
  passwordHintStore: { passwordHints: { maxLength: 128, minLength: 8 } },
});

makeInspectable(initialState);

export const rootStore = initialState;